import { Box, Button } from '@mui/material'

const GameFormCTAButtons = ({ formGameData, handleChange }) => {
    return (
        <Box display="flex" flexDirection="row" gap={2} mt={2}>
            {formGameData?._id && <Button
                fullWidth
                variant="contained"
                sx={{ height: 50, backgroundColor: "red", color: 'white', fontSize: 16 }}
                onClick={() => {
                    handleChange("delete")
                }}
            disabled={true}
            >
                {"Delete Game"}
            </Button>}
            <Button
                fullWidth
                variant="contained"
                sx={{ height: 50, backgroundColor: "#a855f7", color: 'white', fontSize: 16 }}
                onClick={() => {
                    handleChange(formGameData?._id ? "update" : "create")
                }}
            // disabled={!isValidNew}
            >
                {formGameData?._id ? "Update Game" : "Add Game"}
            </Button>
        </Box>
    )
}

export default GameFormCTAButtons
